import { render, staticRenderFns } from "./HealthcheckDialog.vue?vue&type=template&id=83189630&scoped=true"
import script from "./HealthcheckDialog.vue?vue&type=script&lang=js"
export * from "./HealthcheckDialog.vue?vue&type=script&lang=js"
import style0 from "./HealthcheckDialog.vue?vue&type=style&index=0&id=83189630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83189630",
  null
  
)

export default component.exports